import { gql, useMutation } from '@apollo/client';

import { Category } from '@work4all/models/lib/Classes/Category.entity';
import { CategoryClass } from '@work4all/models/lib/Classes/CategoryClass.entity';
import { InputVerteiler } from '@work4all/models/lib/Classes/InputVerteiler.entity';
import { InputVerteilerKlasse } from '@work4all/models/lib/Classes/InputVerteilerKlasse.entity';

const PARENT_COMPANY_CATEGORY_MUTATION = gql`
  mutation upsertParentCompanyCategory($input: InputVerteilerKlasse!) {
    upsertParentCompanyCategory(input: $input) {
      id: code
      isFirmCategory: firmenverteiler
    }
  }
`;

const COMPANY_CATEGORY_MUTATION = gql`
  mutation upsertCompanyCategory($input: InputVerteiler!) {
    upsertCompanyCategory(input: $input) {
      id: code
      name
    }
  }
`;

export type MutateParentCompanyCategoryVars = {
  input: InputVerteilerKlasse;
};

export type MutateCompanyCategoryVars = {
  input: InputVerteiler;
};

export type MutateParentCompanyCategoryResponse = {
  upsertParentCompanyCategory: CategoryClass;
};

export type MutateCompanyCategoryResponse = {
  upsertCompanyCategory: Category;
};

export const useMutateParentCategories = () => {
  const [mutateParentCompanyCategory] = useMutation<
    MutateParentCompanyCategoryResponse,
    MutateParentCompanyCategoryVars
  >(PARENT_COMPANY_CATEGORY_MUTATION);

  return {
    mutateCategory: mutateParentCompanyCategory,
    type: 'upsertParentCompanyCategory',
    isDraggable: true,
    maxDepth: null,
  };
};

export const useMutateCategories = () => {
  const [mutateCompanyCategory] = useMutation<
    MutateCompanyCategoryResponse,
    MutateCompanyCategoryVars
  >(COMPANY_CATEGORY_MUTATION);

  return {
    mutateCategory: mutateCompanyCategory,
    type: 'upsertCompanyCategory',
    isDraggable: true,
    maxDepth: null,
  };
};
